import angular from 'angular';

import { ActivitiesComponent } from './components/activities.component';
import { NewActivityModalComponent } from './components/new-activity-modal.component';
import { UpdateActivityModalComponent } from './components/update-activity-modal.component';

import { activityLegendDirective } from './directives/activity-legend.directive';
import { activityDirective } from './directives/activity.directive';
import { draggableActivityDirective } from './directives/draggable-activity.directive';

import { ActivityModalService } from './services/activity-modal.service';
import { ActivityService } from './services/activity.service';

const activities = angular.module('activities', 
    [
        'ui.bootstrap',
        'commons',
        'members'
    ]
);

activities.component('activities', ActivitiesComponent);
activities.component('newActivityModal', NewActivityModalComponent);
activities.component('updateActivityModal', UpdateActivityModalComponent);

activities.directive('activityLegend', activityLegendDirective);
activities.directive('activity', activityDirective);
activities.directive('draggableActivity', draggableActivityDirective);

activities.service('Activity', ActivityService);
activities.service('ActivityModal', ActivityModalService);

export const ActivitiesModule = activities;